import { StyleSheet, Platform } from "react-native";


const styles = StyleSheet.create({
    content: {
        paddingHorizontal: 25,
        maxWidth: 1170,
        width: '100%',
        alignSelf: 'center',
        marginHorizontal: 'auto'
    },
    contentPurchaseAmount: {
        alignItems: "center"
    },
    title: {
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 'bold',
        marginTop: 20
    },
    titlePurchase: {
        color: "black",
        textAlign: 'center',
        marginBottom: 20
    },
    iconSelect: {
        width: 17,
        height: 18
    },
    contentSelect: {
        alignSelf: 'center'
    },
    dropdown: {
        width: '70%',
        height: 30,
        marginTop: 15
    },
    textAmount: {
        fontSize: 18,
        color: '#5eb2a9',
        fontWeight: 'bold',
        marginTop: 35
    },
    price: {
        textAlign: 'center',
        fontSize: 12,
        marginTop: 15
    },
    action_buttons_container: {
        paddingHorizontal: "30%",
        marginTop: 15,
        marginBottom: 40
    },
    action_button: {
        padding: 10,
        borderRadius: 20,
    },
    action_button_text: {
        textTransform: "uppercase",
        fontWeight: "bold",
        color: "#FFF",
        textAlign: 'center'
    },
});

export default styles;
